export enum ProductsStateActionsSource {
    WHITELISTING_PRODUCTS_FAILED = 'WHITELISTING_PRODUCTS_FAILED',
    SYNCHRONIZATION_FAILED = 'SYNCHRONIZATION_FAILED',
    UN_WHITELISTING_PRODUCTS_FAILED = 'UN_WHITELISTING_PRODUCTS_FAILED',
    FETCHING_ALL_PRODUCTS_FAILED = 'FETCHING_ALL_PRODUCTS_FAILED',
    SORTING_PRODUCTS = 'SORTING_PRODUCTS',
}
